<template>
  <div>
    <label
        v-if="label"
        :for="id"
        :class="`${disabled && 'cursor-not-allowed'} inline-flex items-center gap-2`"
    >
      <span
          class="relative flex items-center justify-center rounded-md
         shadow-[0px_1px_2px_0px_#2A33420D] ring-1 ring-inset box-border"
          :class="[
                  disabled ? '!bg-zinc-100 !ring-gray-200' : '',
                  value ? 'bg-primary ring-primary' : 'bg-white',
                  errors.length ? 'ring-error' : 'ring-gray-200'
                  ]"
          style="width: 20px; height: 20px; min-width: 20px; min-height: 20px;"
      >
  <Icon
      name="check"
      class="pointer-events-none absolute transition-opacity duration-200 text-white"
      :class="[
      value ? 'opacity-100' : 'opacity-0',
      disabled ? 'text-zinc-500' : 'text-white'
    ]"
  />
</span>

      <span
          :class="`${errors.length ? 'text-error' : 'text-zinc-800'} leading-normal`"
      >
        {{ `${label}${required ? '*' : ''}` }}
        <slot></slot>
      </span>
    </label>

    <input
        :id="id"
        :checked="value"
        :disabled="disabled"
        type="checkbox"
        class="sr-only"
        @change="handleChange"
    />

    <div v-if="errors.length" class="mt-2 space-y-1">
      <span
          v-for="(error, index) in errors"
          :key="index"
          class="block text-xs text-error"
      >
        {{ error }}
      </span>
    </div>
  </div>
</template>

<script setup>
import {Icon} from '@/components/block/icon';

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  label: {
    type: String,
    default: ''
  },
  required: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  value: {
    type: Boolean,
    required: true
  },
  errors: {
    type: Array,
    default: () => []
  }
});

const emits = defineEmits(['update:value', 'update:errors']);

function handleChange(event) {
  emits('update:value', event.target.checked);
  emits('update:errors', []);
}
</script>